import AppDispatcher from '../dispatcher/AppDispatcher';
import AuthConstants from '../constants/AuthConstants';
import AuthAPI from '../utils/AuthAPI';

export default {

  logUserIn: (login, password) => {
    AuthAPI
      .logUserIn(login, password)
      .then(partner => {
        AppDispatcher.dispatch({
          actionType: AuthConstants.LOGIN_USER,
          user: partner
        });
      })
      .catch(message => {
        AppDispatcher.dispatch({
          actionType: AuthConstants.LOGIN_USER_ERROR,
          message: message
        });
      });
  },

  logUserOut: () => {
    AppDispatcher.dispatch({
      actionType: AuthConstants.LOGOUT_USER
    });
  }

}



// WEBPACK FOOTER //
// ./src/actions/AuthActions.js